export const PORTAL_RELEASE = {
  surface: 'portal' as const,
  productVersion: String(import.meta.env.VITE_PACKPROOF_PRODUCT_VERSION ?? '0.9.7.0').trim() || '0.9.7.0',
  gitSha: String(import.meta.env.VITE_PACKPROOF_GIT_SHA ?? 'SOURCE_TREE').trim() || 'SOURCE_TREE',
  builtAt: String(import.meta.env.VITE_PACKPROOF_BUILT_AT ?? 'SOURCE_TREE').trim() || 'SOURCE_TREE',
};
